import React, { useState, useEffect } from 'react';
import Calendar from '../components/Calendar';
import SyncStatus from '../components/SyncStatus';
import Stats from '../components/Stats';
import '../styles/Dashboard.css';

function Dashboard() {
  const [property, setProperty] = useState(null);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [refreshing, setRefreshing] = useState(false);

  const token = localStorage.getItem('token');

  useEffect(() => {
    loadDashboardData();
  }, []);

  const loadDashboardData = async () => {
    setLoading(true);
    setError('');

    try {
      const propertyRes = await fetch('/api/dashboard/property', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const statsRes = await fetch('/api/dashboard/stats', {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!propertyRes.ok || !statsRes.ok) {
        throw new Error('Failed to load dashboard data');
      }

      const propertyData = await propertyRes.json();
      const statsData = await statsRes.json();

      setProperty(propertyData);
      setStats(statsData);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = async () => {
    setRefreshing(true);
    // Manual refresh - will trigger next sync cycle
    await new Promise(resolve => setTimeout(resolve, 1000));
    await loadDashboardData();
    setRefreshing(false);
  };

  if (loading) {
    return <div className="dashboard-loading">Loading dashboard...</div>;
  }

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <div>
          <h1>Calendar Dashboard</h1>
          {property && <p className="property-name">{property.name}</p>}
        </div>
        <button
          className="btn btn-secondary"
          onClick={handleRefresh}
          disabled={refreshing}
        >
          {refreshing ? 'Refreshing...' : 'Refresh'}
        </button>
      </div>

      {error && <div className="error-banner">{error}</div>}

      {stats && <Stats stats={stats} />}

      <div className="dashboard-content">
        <div className="calendar-section">
          <h2>Calendar View</h2>
          <Calendar token={token} />
        </div>

        <div className="sync-section">
          <h2>Sync Status</h2>
          <SyncStatus token={token} />
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
